import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader } from 'lucide-react';

const UserRouteGuard = () => {
    const { token, loading } = useAuth();

    if (loading) {
        // Show a loading spinner or a blank screen while checking auth state
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-900">
                <Loader className="animate-spin text-white" />
            </div>
        );
    }

    if (!token) {
        // If not loading and no token, redirect to login
        return <Navigate to="/login" replace />;
    }

    // If not loading and token exists, render the protected route
    return <Outlet />;
};

export default UserRouteGuard; 